import { EventEmitter } from "@angular/core";
import * as i0 from "@angular/core";
export class HeaderService {
    constructor() {
        this.isSocialShareChange = new EventEmitter();
    }
    isSocialShare(status) {
        this.isSocialShareChange.emit(status);
    }
}
HeaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HeaderService_Factory() { return new HeaderService(); }, token: HeaderService, providedIn: "root" });
